<template>
  <div >
    <navbar/>
    <div class="container container-principal">
      <div class="row" v-if="user">
        <sub-menu-link :menu-link="$root.SubMenuLink" 
                       :menu-btn="$root.SubMenuBtn">          
        </sub-menu-link>
      </div>
      <div class="row">
          <child/>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from '~/components/basicos/Navbar'
import { mapGetters } from 'vuex'

export default {
  name: 'MainLayout',

  components: {
    Navbar
  },

  computed: mapGetters({
    user: 'auth/user'
  })

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue